export class Configuracoes {

    imovelLogradouro: string
    imovelNumero: number
    imovelComplemento: string
    imovelBairro: string
    imovelCidade: string
    imovelUF: string
    imovelUso: string
    imovelCep: string
    imovelAlarme: number
    imovelTipoResidencia: number
    imovelConstrucao: number
    imovelOcupacao: number
    imovelObjetoSegurado: number
    imovelAtividadeProfissionalLocal: boolean
    imovelPossuiAlarme: boolean
    imovelPossuiVigilancia24hs: boolean
    isDanosIncendioRaioExplosao: number
    isDanosEletricos: number
    isDanosImpactoVeiculo: number
    isDanosAluguel: number
    isDanosRoubo: number
    responsabilidadeCivil: number
    isDanosAlagamento: number
    isDanosDesmoronamento: number
    vidros: number
    isDanosMateriais: number
    despesaFixa: number
    assist24hs: number
    fidelidade: number
    funeral:any

    constructor(){

        this.imovelLogradouro = null;
        this.imovelNumero = null;
        this.imovelComplemento = null;
        this.imovelBairro = null;
        this.imovelCidade = null;
        this.imovelUF = null;
        this.imovelUso = null;
        this.imovelCep = null;
        this.imovelAlarme = null;
        this.imovelTipoResidencia = null;
        this.imovelConstrucao = null;
        this.imovelOcupacao = null;
        this.imovelObjetoSegurado = null;
        this.imovelAtividadeProfissionalLocal = null;
        this.imovelPossuiAlarme = null;
        this.imovelPossuiVigilancia24hs = null;
        this.isDanosIncendioRaioExplosao = null;
        this.isDanosEletricos = null;
        this.isDanosImpactoVeiculo = null;
        this.isDanosAluguel = null;
        this.isDanosRoubo = null;
        this.responsabilidadeCivil = null;
        this.isDanosAlagamento = null;
        this.isDanosDesmoronamento = null;
        this.vidros = null;
        this.isDanosMateriais = null;
        this.despesaFixa = null;
        this.assist24hs = null;
        this.fidelidade = null;
        this.funeral = {tipo: 0, valor: 0};

    }

}